import {
    AI_CHARGE_LIMIT_ERROR_CODE,
    AI_LIMIT_ERROR_CODE,
    PIC_ANALYSIS_ERROR_CODE,
    PIC_SIZE_ERROR_CODE
} from '~/constants';
import Intl from '@fx-ui/intl';

/**
 * @param errorCode - 接口返回错误码
 */
export const getAiWarning = (errorCode?: number): string | undefined => {
    switch (errorCode) {
        case AI_LIMIT_ERROR_CODE:
            return Intl.get('error.22004');
        case AI_CHARGE_LIMIT_ERROR_CODE:
            return Intl.get('error.22021');
        case PIC_SIZE_ERROR_CODE:
            return Intl.get('error.22019');
        case PIC_ANALYSIS_ERROR_CODE:
            return Intl.get('error.22020');
        default:
            return undefined;
    }
};
